import { cn } from "@/lib/utils";
import icArrowLeft from "@/assets/icons/ic-arrow-left.svg";
import icArrowLeftDisabled from "@/assets/icons/ic-arrow-left-disabled.svg";
import icArrowRight from "@/assets/icons/ic-arrow-right.svg";
import icArrowRightDisabled from "@/assets/icons/ic-arrow-right-disabled.svg";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

function getPageNumbers(current: number, total: number): (number | "ellipsis")[] {
  // Nếu ≤ 5 trang: hiển thị tất cả
  if (total <= 5) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  // Xác định 3 trang căn giữa xung quanh current
  let start: number;
  if (current <= 2) {
    start = 1;
  } else if (current >= total - 1) {
    start = total - 2;
  } else {
    start = current - 1;
  }

  const middlePages = [start, start + 1, start + 2];
  const pages: (number | "ellipsis")[] = [];

  // Ellipsis trái nếu không bắt đầu từ trang 1
  if (middlePages[0] > 1) {
    pages.push("ellipsis");
  }

  pages.push(...middlePages);

  // Ellipsis phải nếu không kết thúc ở trang cuối
  if (middlePages[2] < total) {
    pages.push("ellipsis");
  }

  return pages;
}

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  className,
}: PaginationProps) => {
  const canGoPrev = currentPage > 1;
  const canGoNext = currentPage < totalPages;
  const pages = getPageNumbers(currentPage, totalPages);

  return (
    <div className={cn("flex items-center gap-4", className)}>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!canGoPrev}
        className="w-10 h-10 rounded-full flex items-center justify-center"
      >
        <img
          src={canGoPrev ? icArrowLeft : icArrowLeftDisabled}
          alt="Previous"
          className="w-5 h-5"
        />
      </button>

      <div className="flex items-center gap-1">
        {pages.map((page, idx) =>
          page === "ellipsis" ? (
            <span
              key={`ellipsis-${idx}`}
              className="w-10 h-10 flex items-center justify-center text-[14x] text-[#000000]"
            >
              ...
            </span>
          ) : (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={cn(
                "w-10 h-10 rounded text-[14px] text-[#000000] transition-colors",
                page === currentPage ? "bg-[#0000000B] font-bold" : "font-normal ",
              )}
            >
              {page}
            </button>
          ),
        )}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!canGoNext}
        className="w-10 h-10 rounded-full flex items-center justify-center"
      >
        <img src={canGoNext ? icArrowRight : icArrowRightDisabled} alt="Next" className="w-5 h-5" />
      </button>
    </div>
  );
};

export default Pagination;
